"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMultiProducts = void 0;
var useMpState_1 = require("./useMpState");
var useMultiProducts = function (props) {
    var isSelected = props === null || props === void 0 ? void 0 : props.isSelected;
    var _a = (0, useMpState_1.useMpState)(), isLoading = _a.isLoading, multiProducts = _a.multiProducts;
    return {
        isLoading: isLoading,
        multiProducts: isSelected
            ? multiProducts.filter(function (item) { return item.isSelected; })
            : multiProducts,
    };
};
exports.useMultiProducts = useMultiProducts;
